import { Box, Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { FC, useCallback } from "react";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { Projeto, ProjetoTipoType } from "../../types";
import api, { STATUS_CODE } from "src/framework/providers/api";
import adminStore from "src/store/AdminStore";
import { useHistory } from "react-router-dom";
import { notifierStore } from "src/framework/store/NotifierStore";

interface ModalReativarPropostasParams {
    open: boolean;
    setOpenModal: Function;
    projeto: Projeto;
    reativar: boolean;
    onSuccess: ()=>void;
}

const getUrlEdicaoReativacao = (tipo: ProjetoTipoType, segmento: string, idProjeto: number, codigoVenda: string) => {
    const projetoHibrido = codigoVenda.includes("HIBRI")

    const urls: {[index: string]: Record<string,string> } = {
        "dimensionado": {
            "distribuicao_offgrid": `/projetos/${idProjeto}/offgrid/edicao`,
        },
        "personalizado": {
            "distribuicao_offgrid": `/projetos/${idProjeto}/personalizado_offgrid/edicao`,
        }
    }

    let url = urls[tipo]?.[segmento] || `/projetos/${idProjeto}/edicao`
   
    if (projetoHibrido) {
        url = `/projetos/${idProjeto}/hibrido/edicao`
    }

    if(projetoHibrido && tipo === "personalizado"){
        url = `/projetos/${idProjeto}/personalizado_hibrido/edicao`
    }

    return `${url}?reativar=true`
}

const ModalReativarProposta: FC<ModalReativarPropostasParams> = (modalReativarPropostasParams) => {
    
    const history = useHistory();
    
    const handleClose = (success?: boolean) => {
        modalReativarPropostasParams.setOpenModal(false);
    };

    const onConfirm = useCallback(async () => {
            if (!modalReativarPropostasParams.projeto?.codigo_venda) return;
            if (!modalReativarPropostasParams.projeto?.id) return;

            let vigencia = true
            if (modalReativarPropostasParams.projeto?.id) {
                await adminStore.buscarProjeto(modalReativarPropostasParams.projeto?.id, true).then(resp => {
                    if (!resp?.length) vigencia = false;
                });
            }
            if (!vigencia) return;

            notifierStore.setOpen(false);

            if(!modalReativarPropostasParams.reativar) {
                
                //apenas reencaminha para edição com as flags de reativar e recalcular
                if (modalReativarPropostasParams.projeto.tipo && modalReativarPropostasParams.projeto.segmento && modalReativarPropostasParams.projeto.id) {
                    const urlRedirect = getUrlEdicaoReativacao(modalReativarPropostasParams.projeto.tipo, modalReativarPropostasParams.projeto.segmento, modalReativarPropostasParams.projeto.id, modalReativarPropostasParams.projeto.codigo_venda)
                    history.replace( urlRedirect)
                }
                return;
            }
    
            const payload = {
                projeto_original_id: modalReativarPropostasParams.projeto.id,
                reativar_projeto: true,
            }
    
            const result = await api.post({
                url: "/projetos/clonagem",
                data: payload
            })
    
            if (result.statusCode === STATUS_CODE.CREATED) {
    
                notifierStore.setNotifier({
                    title: "Sucesso!",
                    content: [
                        `O projeto ${modalReativarPropostasParams.projeto.codigo_venda} foi reativado com sucesso.`
                    ],
                    onClose: () => {
                        notifierStore.setOpen(false);
                        modalReativarPropostasParams.onSuccess();
                        modalReativarPropostasParams.setOpenModal(false, false, null);
                    },
                    timeOut: 4000,
                    onFinishTimeout: () => {
                        notifierStore.setOpen(false);
                        modalReativarPropostasParams.onSuccess();
                        modalReativarPropostasParams.setOpenModal(false, false, null);
                    }
                })
                notifierStore.setOpen(true);
            }
        }, [history, modalReativarPropostasParams])

    return (
        <Dialog
            open={modalReativarPropostasParams.open}
            onClose={() => handleClose() }
            maxWidth='md'
        >
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Box component={"h2"}>Atenção!</Box>
                            {modalReativarPropostasParams.reativar ? 
                                <Box component={"p"}>Ao reativar este projeto, os cálculos serão refeitos automaticamente, <br/>
                                    considerando os itens e regras atualmente disponíveis e a tabela de preços <br/> vigente. 
                                    Os descontos serão removidos.</Box>
                            :   <Box component={"p"}>Reativação do projeto - {modalReativarPropostasParams.projeto?.codigo_venda} <br /> <br />
                                    Alguns itens do projeto não estão mais disponíveis. <br />
                                    Você será direcionado para a edição do projeto para revisar e ajustar a  <br /> 
                                    solução conforme as configurações atuais.</Box>}
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <FlatButton
                    color="inherit"
                    variant="contained"
                    disableElevation
                    text="Cancelar"
                    onClick={() => handleClose(false) }
                />
                <FlatButton
                    color="primary"
                    variant="contained"
                    disableElevation
                    text="Continuar"
                    onClick={onConfirm}
                />
            </DialogActions>
        </Dialog>
    )
}

export { ModalReativarProposta }

